import { render, staticRenderFns } from "./SettingsGroupMembers.vue?vue&type=template&id=b0ddaae2&"
import script from "./SettingsGroupMembers.vue?vue&type=script&lang=js&"
export * from "./SettingsGroupMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports